import { useTranslation } from "react-i18next";

export default function ServicesPanel() {
  const { t } = useTranslation();
  const items = [
    { k: "s1", icon: "ri-heart-pulse-line" },
    { k: "s2", icon: "ri-first-aid-kit-line" },
    { k: "s3", icon: "ri-capsule-line" },
    { k: "s4", icon: "ri-hospital-line" },
  ];
  return (
    <section className="panel" data-side="right" id="services-panel">
      <img
        className="panel-bg"
        src="https://readdy.ai/api/search-image?query=Soft%20daylight%20interior%20of%20a%20private%20home%20living%20room%20with%20pale%20linen%20sofa%2C%20wooden%20side%20table%20holding%20a%20blood%20pressure%20cuff%20and%20sterile%20bandages%20laid%20out%20neatly%2C%20sheer%20curtains%20diffusing%20bright%20morning%20light%2C%20airy%20pale%20blue%20white%20palette%20with%20teal%20accents%2C%20quiet%20clinical%20precision%2C%20editorial%20photography%2C%20no%20people%2C%20no%20text&width=2400&height=1350&seq=nurse-services-02&orientation=landscape"
        alt={t("services.imageAlt")}
        width={2400}
        height={1350}
        loading="eager"
        fetchPriority="low"
        decoding="async"
        data-parallax="0.32"
      />
      <div className="panel-veil" />
      <div className="panel-copy" data-parallax="-0.08">
        <p className="stamp" data-reveal>{t("services.stamp")}</p>
        <h2 data-reveal dangerouslySetInnerHTML={{ __html: t("services.h2") }} />
        <p className="sub" data-reveal>{t("services.sub")}</p>
        <ul className="num-list">
          {items.map((it, i) => (
            <li key={it.k} data-reveal>
              <span className="w-9 h-9 flex items-center justify-center rounded-full flex-none" style={{ background: "var(--accent)", color: "#f4fbfa" }}>
                <i className={`${it.icon} text-[17px]`} aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <p className="t">{t(`services.${it.k}t`)}</p>
                <p className="d">{t(`services.${it.k}d`)}</p>
              </div>
              <span className="idx ml-auto self-center">{`0${i + 1}`}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}